import { render, staticRenderFns } from "./OnboardingLegalRepresentativePage.vue?vue&type=template&id=dd02d0ee&scoped=true&"
import script from "./OnboardingLegalRepresentativePage.vue?vue&type=script&lang=js&"
export * from "./OnboardingLegalRepresentativePage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingLegalRepresentativePage.vue?vue&type=style&index=0&id=dd02d0ee&prod&lang=scss&"
import style1 from "./OnboardingLegalRepresentativePage.vue?vue&type=style&index=1&id=dd02d0ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd02d0ee",
  null
  
)

export default component.exports